<div *ngIf="item && item.cells" class="container flex flex-row justify-between items-center">
  <a (click)=onHyperLinkClick() [analyticsAction]="item.cells[fieldDefinition.key]?.displayText"
     [ngClass]="!item.isReadOnly || fieldDefinition?.metaData?.CanCellUnlock === 'true' ? 'link-color' : 'disabled'"
     analyticsCategory="link-cell-viewer"
     class="flex flex-row justify-start items-center" particleAnalytics>
    <div class="grid-cell-ellipsis"
         matTooltip="{{item.cells[fieldDefinition.key] ? (item.cells[this.fieldDefinition.key].value?.toolTip ? item.cells[this.fieldDefinition.key].value?.toolTip : item.cells[fieldDefinition.key].displayText) : ''}}">
      {{item.cells[fieldDefinition.key] ? item.cells[fieldDefinition.key].displayText : ''}}
    </div>
  </a>
  <button
    (click)="onEditClick('Edit')"
    *ngIf="!item.cells['IsDefault']?.value && !fieldDefinition.isReadOnly && (!item.isReadOnly || fieldDefinition?.metaData?.CanCellUnlock === 'true')"
    class="icon-dropdown-button" mat-icon-button
    matTooltip="Edit {{this.fieldDefinition.header}}">
    <mat-icon>create</mat-icon>
  </button>
</div>
